export function canGenerateMatchReport({
  isAdmin,
  partido,
  reportableCompetitions = [],
}) {
  if (isAdmin || !partido?.idCompeticion) {
    return true;
  }

  return reportableCompetitions.some(
    (competition) =>
      String(competition.competition_id) === String(partido.idCompeticion)
      && String(competition.season_id) === String(partido.idTemporada)
  );
}
